import Facebook from "../images/Meta_Logo.png";
import Star from "../images/Loom_Logo.svg";
import LinkedIn from "../images/linkedin.svg";

export const Jobs = [
  {
    id: 0,
    Image: Facebook,
    title: "Product Manager—Remote",
    company: "Meta",
    location: "USA",
    mode: "Remote",
    status: "Full-time",
    salary: "120k - 130k",
    timePast: "5mins ago",
  },
  {
    id: 1,
    Image: Star,
    title: "Data Analytics",
    company: "Loom Inc.",
    location: "Australia",
    mode: "",
    status: "Full-time",
    salary: "120k - 130k",
    timePast: "18hrs ago",
  },
  {
    id: 2,
    Image: LinkedIn,
    title: "Data Analytics",
    company: "Loom Inc.",
    location: "Australia",
    mode: "",
    status: "Full-time",
    salary: "120k - 130k",
    timePast: "18hrs ago",
  },
  {
    id: 3,
    Image: Star,
    title: "Data Analytics",
    company: "Loom Inc.",
    location: "Australia",
    mode: "",
    status: "Full-time",
    salary: "120k - 130k",
    timePast: "18hrs ago",
  },
  {
    id: 4,
    Image: Star,
    title: "Data Analytics",
    company: "Loom Inc.",
    location: "Australia",
    mode: "",
    status: "Full-time",
    salary: "120k - 130k",
    timePast: "18hrs ago",
  },
  {
    id: 5,
    Image: Star,
    title: "Data Analytics",
    company: "Loom Inc.",
    location: "Australia",
    mode: "",
    status: "Full-time",
    salary: "120k - 130k",
    timePast: "18hrs ago",
  },
  {
    id: 6,
    Image: Facebook,
    title: "Product Manager—Remote",
    company: "Meta",
    location: "USA",
    mode: "Remote",
    status: "Full-time",
    salary: "120k - 130k",
    timePast: "5mins ago",
  },
];

const communityMembersAvatars = [
  "https://s3-alpha-sig.figma.com/img/4efe/2013/097787063aedae97d1a07c285f69b7c2?Expires=1658102400&Signature=SdBAZ8kJ8HgZBj~W~RgwgQY6Ql3B8ZVb9plc24~0ibapeUA-Xu9HiRwH7MLbmCSEWzhrT63vRF3UzLXfoWCwLzuRJhT5Ndy72E4FEKjyWzblypNM6mPyHsjetRRKR7FbhcwZHR4~gtOqA0MyEuSBGCl444b~T5ilOkuzhN6W7w3baDEnMr9oSl9zLpvEFBrLY59UDyf4dPy3Ow7CcZf5w4ixe8xRhnJSTBJe7StIJTnuBUamE3T9F~kqYNT9jV-v3pBT9CjIHquy9x1xN~tfotvcBNSs7uCsHiMLLNbFHng5vOg~3wL9H8o~f2pH-RYK2m4o8dRZ-ckJxrIt8EThww__&Key-Pair-Id=APKAINTVSUGEWH5XD5UA",
  "https://s3-alpha-sig.figma.com/img/433d/9602/92e5f9ab3789c788a9900fa9aeae9751?Expires=1658102400&Signature=c2WFZ8VA~6iMG97nvegiWZ8Lk77c6YQD6ZH3L~rppDboia-1Js6wYLcc4EJFoU-ePPgjMkg8aIN7wOW1eicI9En87HsSlQTyoXKjI~PykI~~OLMqT2D5YwHXSX0~G84CblxjE0h7mi7yW3qmXmBX9L7mhIkXYMOUbcRWgubTKO4DoKrYErr3-iquObzwXFBeIB37WZK7TBJpwZjmeKveEcWuu-VBBy4JWohQDfeb3LVZrxlNJe~GWg3E3Zma54TmnMfzIR1t1HXDXX2Bvbj8XM1PZZygIjLZn7PaceSKse4bXe2sBRWEQ5-H-c4-RVNsX2B~IQFPM7Gi85826tJpOw__&Key-Pair-Id=APKAINTVSUGEWH5XD5UA",
];

const AvatarBgs = ["#BCAEFF", "#F2C94C", "#8CDFB3", "#FAB592"];

const CommunityMembersAvatarList = () => [
  {
    id: 0,
    memberAvatar: communityMembersAvatars[0],
    AvatarBg: AvatarBgs[Math.floor(Math.random() * AvatarBgs.length)],
  },
  {
    id: 1,
    memberAvatar: communityMembersAvatars[1],
    AvatarBg: AvatarBgs[Math.floor(Math.random() * AvatarBgs.length)],
  },
  {
    id: 2,
    memberAvatar: communityMembersAvatars[0],
    AvatarBg: AvatarBgs[Math.floor(Math.random() * AvatarBgs.length)],
  },
];

export const CommunityChannels = [
  {
    id: 0,
    channel: "Product Management",
    memberAvatars: CommunityMembersAvatarList(),
    membersCount: 107,
  },
  {
    id: 1,
    channel: "Product Design",
    memberAvatars: CommunityMembersAvatarList(),
    membersCount: 291,
  },
  {
    id: 2,
    channel: "Web Development",
    memberAvatars: CommunityMembersAvatarList(),
    membersCount: 21,
  },
];

export const PodcastsList = [
  {
    id: 0,
    title: "Women In Tech Q&A Series",
    artiste: "Martyna Lewinska, Co-Founder and CTO at Fiat Republic",
    time: "12mins",
    img: "https://s3-alpha-sig.figma.com/img/644e/6b4b/a09a40e7adcf80041887a4a17703a183?Expires=1658102400&Signature=ZkB2Tpzo-c2FyyBgerM8C4r2F~c4zrak3HY2kYVKgWwckkMv-xwHGjz6w1udxJdYSpxNRay6xEzODDJdE5Ogeb-vgheNudgK5IoT4IJRwVhbeCnIZ2r7ajYg2Og1uzHx5CqIu-cswx4FSJ60CkEbpKzLSiGAD-XSK0xoTgwq1ytfgfbfWzNEUQ5bRlmVND4GTROxcc7hddeOKrOR8sWeEtGjCU0hWQiYeDwy3GGyWhM4rdu2295ZIwWT6isAW4~5Q6Lb3NjhIarRUrzSZjvJKlbcUiG5h0zSR1HtSG0jN6bOlcpMIQ18B8sFd3zqANTe~GD6fjZ2K63Z2DgFnYM43Q__&Key-Pair-Id=APKAINTVSUGEWH5XD5UA",
  },
  {
    id: 1,
    title: "Women In Tech Q&A Series",
    artiste: "Martyna Lewinska, Co-Founder and CTO at Fiat Republic",
    time: "12mins",
    img: "https://s3-alpha-sig.figma.com/img/644e/6b4b/a09a40e7adcf80041887a4a17703a183?Expires=1658102400&Signature=ZkB2Tpzo-c2FyyBgerM8C4r2F~c4zrak3HY2kYVKgWwckkMv-xwHGjz6w1udxJdYSpxNRay6xEzODDJdE5Ogeb-vgheNudgK5IoT4IJRwVhbeCnIZ2r7ajYg2Og1uzHx5CqIu-cswx4FSJ60CkEbpKzLSiGAD-XSK0xoTgwq1ytfgfbfWzNEUQ5bRlmVND4GTROxcc7hddeOKrOR8sWeEtGjCU0hWQiYeDwy3GGyWhM4rdu2295ZIwWT6isAW4~5Q6Lb3NjhIarRUrzSZjvJKlbcUiG5h0zSR1HtSG0jN6bOlcpMIQ18B8sFd3zqANTe~GD6fjZ2K63Z2DgFnYM43Q__&Key-Pair-Id=APKAINTVSUGEWH5XD5UA",
  },
];
